import React from "react";

import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import DirectionsWalkOutlinedIcon from "@mui/icons-material/DirectionsWalkOutlined";
import AccessibilityNewIcon from "@mui/icons-material/AccessibilityNew";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import RemoveOutlinedIcon from "@mui/icons-material/RemoveOutlined";

import { ListStyled, MainIcon } from "../../theme";

export const AccountDetail = ({
  account,
  Edit,
  Delete,
  Add,
  Remove,
  isTechnician,
}) => {
  const editHandler = () => Edit && Edit(account);
  const deleteHandler = () => Delete && Delete(account);
  const addHandler = () => Add && Add(account.id);
  const removeHandler = () => Remove && Remove(account.id);

  let iconElement = <DirectionsWalkOutlinedIcon />;
  let colorShade = 0.5;
  if (account?.role?.code === 30) {
    colorShade = 0.8;
    iconElement = <AccessibilityNewIcon />;
  } else if (account?.role?.code === 10) {
    colorShade = 1;
    iconElement = <PeopleAltOutlinedIcon />;
  }

  return (
    <ListStyled equipment>
      <MainIcon colorShade={colorShade}>{iconElement}</MainIcon>
      <div className="detail">
        {isTechnician ? account.account.name : account.name}
        <span>{isTechnician ? account.account.email : account.email}</span>
      </div>
      {Remove && (
        <span className="remove" onClick={removeHandler}>
          <RemoveOutlinedIcon />
        </span>
      )}
      {Add && (
        <span className="add" onClick={addHandler}>
          <AddOutlinedIcon />
        </span>
      )}
      {Edit && (
        <span className="edit" onClick={editHandler}>
          <EditOutlinedIcon />
        </span>
      )}
      {Delete && (
        <span className="delete" onClick={deleteHandler}>
          <DeleteOutlineOutlinedIcon />
        </span>
      )}
    </ListStyled>
  );
};
